import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';

import { getReport, getTipsReport } from './selectors';
import { fetchPayoutReportForShops, fetchDailyPayrollReportForShops } from './actions';
import CommissionSplitsList from './components/CommissionSplitsList';

const mapDispatchToProps = { fetchPayoutReportForShops, fetchDailyPayrollReportForShops };
const mapStateToProps = state => ({
  tipSplitsShops: getTipsReport(state),
  commissionSplitsShops: getReport(state),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(
    (prevProps, nextProps) => (
      !prevProps.tipSplitsShops.length && nextProps.tipSplitsShops.length
    ),
    (props) => {
      props.fetchDailyPayrollReportForShops(props.tipSplitsShops);
    },
  ),
  withPropsOnChange(
    (prevProps, nextProps) => (
      !prevProps.commissionSplitsShops.length && nextProps.commissionSplitsShops.length
    ),
    (props) => {
      props.fetchPayoutReportForShops(props.commissionSplitsShops);
    },
  ),
);

export default enhance(CommissionSplitsList);
